import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { EmbeddableInfographic } from 'site-modules/shared/components/infographics/embeddable-infographic/embeddable-infographic';
import { SelfDrivingCars } from 'site-modules/shared/components/infographics/self-driving-cars/self-driving-cars';

export function InfographicEntry({ entry, className = undefined }) {
  const entryType = entry.metadata('type').value();

  switch (entryType) {
    case 'self-driving-cars': {
      return <SelfDrivingCars className={className} />;
    }
    default: {
      return (
        <EmbeddableInfographic
          imgSrc={entry.metadata('media-image').value()}
          imgAlt={entry.metadata('imageAltText').value()}
          imgUrl={entry.metadata('imageURL').value()}
          clickableUrl={entry.metadata('clickableURL').value()}
          btnText={entry.metadata('buttonTitle').value()}
          hideShareButton={entry.metadata('hideShareButton').value() === 'true'}
        />
      );
    }
  }
}

InfographicEntry.propTypes = {
  entry: CmsEntities.Content.isRequired,
  className: PropTypes.string,
};
